export enum Tab {
  DISCUSSION = 'discussion',
  MEDIA = 'media',
  MEMBERS = 'members',
  ABOUT = 'about',
  EVENTS = 'events',
  CUSTOM = 'custom',
}
